import { Router, RouterModule } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { AuthService } from '../auth.service';
import { Credentials } from "../../user/credentials.model";
import { FormMessage } from 'src/app/ui-design-library/form-message/form-message.model';
import { NgClass } from '@angular/common';
import { ShowErrorComponent } from 'src/app/ui-design-library/forms/show-error/show-error.component';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { FormMessageComponent } from 'src/app/ui-design-library/form-message/form-message.component';

@Component({
  selector: 'fnsr-login',
  standalone: true,
  imports: [RouterModule, NgClass, ShowErrorComponent, IconComponent, ReactiveFormsModule, FormMessageComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form!: FormGroup;
  isLoading = false;
  formMessage?: FormMessage;

  constructor(
    public fb: FormBuilder,
    public authService: AuthService,
    public router: Router
  ) { }

  ngOnInit() {
    this.createForm();
  }

  private createForm(): void {
    this.form = this.fb.group({
      usernameOrEmail: new FormControl('', {
        validators: [Validators.required]
      }),
      password: new FormControl('', { validators: [Validators.required] })
    });
  }

  onSubmit(credentials: Credentials): void {
    this.isLoading = true;
    this.authService.login(credentials).subscribe(
      result => {
        
        this.formMessage = {
          message: result.message,
          messageType: 'success'
          }
          this.authService.setUser(result);
          this.isLoading = false;
          this.router.navigate(['mail']);
      },
      (err: Error) => {
        this.formMessage = {
          message: err.message,
          messageType: 'error'
        };
        this.isLoading = false;
      }
    );
  }

}
